<template>
    <div class="w-100">
        <h4>Contact Details</h4>
        <h5 class="hidden-xs hidden-sm">&nbsp;</h5>

        <table class="table">
            <tbody>
            <tr>
                <td>T-shirt size</td>
                <td>{{ person.tshirt }}</td>
            </tr>
            <tr>
                <td>Email</td>
                <td>{{ person.email }}</td>
            </tr>
            <tr>
                <td>Date of Birth</td>
                <td>{{ person.date_of_birth }}</td>
            </tr>
            <tr>
                <td>Gender</td>
                <td>{{ lodash.startCase(person.gender) }}</td>
            </tr>
            <tr>
                <td>Phone</td>
                <td>{{ person.day_tel }}</td>
            </tr>
            <tr>
                <td>Address</td>
                <td v-html="this.address"></td>
            </tr>
            <tr>
                <td>Person ID</td>
                <td>{{ person.id }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: ['person'],

        data() {
            return {
                lodash: window._,
            };
        },

        computed: {
            address() {
                return [
                    this.person.address.line_1,
                    this.person.address.line_2,
                    this.person.address.town_or_city,
                    this.person.address.county,
                    this.person.address.country,
                    this.person.postcode
                ].filter(item => String(item).trim() !== '').join('<br>');
            }
        },
    }
</script>
